import React from 'react';
import logo from '../assets/logo-semantix.png';
import greyLogo from '../assets/logo-semantix-light-grey.png';
import logo2 from '../assets/logo_gl_AI_CMYK.png';
import greyLogo2 from '../assets/GlobalLink_Grey.png';
import Translator from "./Translator";
import Loader from "./Loader";

export default class WidgetContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0,
        };
    }

    switchTab(tab) {

        this.setState({currentTab: tab});
    }

    render() {
        const tabs = [
            <Translator http={this.props.http} document={this.props.document} data={this.props.data} isStatic={this.props.isStatic}
                        apiKey={this.props.apiKey} styled={this.props.styled} apiEndpoint={this.props.apiEndpoint} updateProviderList={this.props.updateProviderList} documentHidden={this.props.documentHidden}/>,
        ];
        const currentTab = this.state.currentTab;
        const loading = this.props.loading;
        const showLogo = this.props.showLogo;
        const userManualUrl = process.env.API_URL + '/pdf/SSMT_4.0_User_Manual_widget.pdf';

        return (<div className="amt-widget-wrapper">
            {loading ? <Loader/> :
             <div className="amt-widget-container" key="container">
                 <div className="amt-widget-header">
                     {
                         showLogo ? (
                             <div className="header-content">
                                 <img src={logo2} width="220" height="45"/>
                                 <span>Your language technology partner</span>
                             </div>
                         ) : <></>
                     }

                 </div>
                 <div className="amt-widget-body">
                     {tabs[currentTab]}
                 </div>
                 <div className="amt-widget-footer">
                     <span className="powered-by">Powered by <img src={greyLogo2} width="67" height="14"/></span>
                     <span>Do you need Support?&nbsp;<a href="mailto:aisupport@transperfect.com" target="_parent">Contact us</a></span>
                 </div>
             </div>
            }

        </div>)
    }
}
